module.exports = __webpack_public_path__ + "img/image-plus.bf5779e9.svg";